import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiptService } from '../../services/receipt.service';

@Component({
  selector: 'app-thermal-receipt',
  imports: [CommonModule],
  templateUrl: './thermal-receipt.component.html',
  styleUrl: './thermal-receipt.component.scss',
  standalone: true
})
export class ThermalReceiptComponent {
  receiptService = inject(ReceiptService);
  receipt = this.receiptService.activeReceipt;

  setPaperWidth(event: Event): void {
    this.receiptService.paperWidth.set(Number((event.target as HTMLSelectElement).value) === 80 ? 80 : 58);
  }

  onLogoError(event: any) {
    const img = event.target as HTMLImageElement;
    // Fallback order: Explicit URL -> /assets/images/logo.png -> /assets/images/arms.png -> Hide
    if (img.src.includes('logo.png')) {
      img.src = '/assets/images/arms.png';
    } else {
      img.style.display = 'none'; // Give up if fallbacks fail
    }
  }
  formatDetailValue(value: unknown): string { return typeof value === 'number' ? new Intl.NumberFormat('en-UG',{maximumFractionDigits:2}).format(value) : String(value ?? ''); }
}
